export default __webpack_public_path__ + "static/media/timesorange.20bc8e6a.svg";